import axiosInstance from "./api";

// ─── Broadcasts ────────────────────────────────────────────────────────────

export const listBroadcasts = async (params = {}) => {
  return axiosInstance.get("broadcasts/broadcasts/getElms", { params });
};

export const getBroadcast = async (id) => {
  return axiosInstance.get(`broadcasts/broadcasts/getElm/${id}`);
};

export const createBroadcast = async ({ data }) => {
  return axiosInstance.post("broadcasts/broadcasts/createElm", data, {
    _returnRawData: true,
  });
};

export const updateBroadcast = async ({ id, data }) => {
  return axiosInstance.put(`broadcasts/broadcasts/updateElm/${id}`, data, {
    _returnRawData: true,
  });
};

export const deleteBroadcast = async (id) => {
  return axiosInstance.delete(`broadcasts/broadcasts/deleteElm/${id}`, {
    _returnRawData: true,
  });
};

export const uploadBroadcastBanner = async (file) => {
  const formData = new FormData();
  formData.append("image", file);
  return axiosInstance.post("broadcasts/broadcasts/banner", formData, {
    _returnRawData: true,
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// ─── Broadcast Categories ──────────────────────────────────────────────────

export const listBroadcastCategories = async (params = {}) => {
  return axiosInstance.get("broadcasts/categories/getElms", { params });
};

export const getBroadcastCategory = async (id) => {
  return axiosInstance.get(`broadcasts/categories/getElm/${id}`);
};

export const createBroadcastCategoryAPI = async ({ data }) => {
  return axiosInstance.post("broadcasts/categories/createElm", data, {
    _returnRawData: true,
  });
};

export const updateBroadcastCategoryAPI = async ({ id, data }) => {
  return axiosInstance.put(`broadcasts/categories/updateElm/${id}`, data, {
    _returnRawData: true,
  });
};

export const deleteBroadcastCategoryAPI = async (id) => {
  return axiosInstance.delete(`broadcasts/categories/deleteElm/${id}`, {
    _returnRawData: true,
  });
};

export const exportBroadcastsExcel = async (params = {}) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "";
  const query = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== ""),
  ).toString();
  const url = `${baseUrl}/broadcasts/broadcasts/exportExcel${query ? `?${query}` : ""}`;

  const token = axiosInstance._getAccessToken?.();
  const headers = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const response = await fetch(url, { headers, credentials: "include" });
  if (!response.ok) {
    throw new Error(
      `Export thất bại: ${response.status} ${response.statusText}`,
    );
  }
  return response.blob();
};
